module.exports = __webpack_public_path__ + "img/logo_navbar.091e963e.png";